// extracted by mini-css-extract-plugin
export default {"ideas":"Ideas_ideas__iznEp","body":"Ideas_body__UQM6-","title":"Ideas_title__rloBs","text":"Ideas_text__kIqQ4","button":"Ideas_button__+dLi-"};